/**
 * Update 09/10/25
 * ---
 * The code that remains in this file is technically still active/used per the
 * Chrome devtools Coverage tab. At a later date it should be reviewed again,
 * and either updated to remove any dependency jQuery or removed altogether.  
 */

$( document ).ready(function() {

  // Validate email format (RFC-style, practical)
  function isValidEmail(value) {
    if (!value || !value.trim()) return false;
    var re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(value.trim());
  }

  // Normalize phone to E.164 for Klaviyo (+12345678901); returns null if invalid
  function normalizePhone(value) {
    if (!value || !value.trim()) return null;
    var digits = value.replace(/\D/g, '');
    if (digits.length === 10) return '+1' + digits;
    if (digits.length === 11 && digits.charAt(0) === '1') return '+' + digits;
    if (digits.length >= 10) return '+' + digits;
    return null;
  }

  function showWaitlistError(message) {
    var $err = $('#mc-embedded-subscribe-form-waitlist .error_message');
    var $success = $('#mc-embedded-subscribe-form-waitlist .success_message');
    $success.hide();
    $err.html(message).show();
  }

  function hideWaitlistError() {
    $('#mc-embedded-subscribe-form-waitlist .error_message').hide().empty();
  }

  $( ".klaviyo_submit_button" ).on( "click", function(e) {
    e.preventDefault();
    hideWaitlistError();

    var id = $("#mc-embedded-subscribe-form-waitlist #backinstock-variant").val();
    var emailRaw = ($("#mc-embedded-subscribe-form-waitlist #mce-EMAIL").val() || $("#mc-embedded-subscribe-form-waitlist #mce-EMAIL[new-pdp-email]").val() || '').trim();
    var phoneRaw = ($("#mc-embedded-subscribe-form-waitlist #mce-PHONE").val() || '').trim();
    var email = isValidEmail(emailRaw) ? emailRaw : null;
    var phone = normalizePhone(phoneRaw);

    if (!email && !phone) {
      showWaitlistError('Please enter a valid email address or phone number.');
      return;
    }
    if (emailRaw && !email) {
      showWaitlistError('Please enter a valid email address.');
      return;
    }
    if (phoneRaw && !phone) {
      showWaitlistError('Please enter a valid phone number (e.g. +1 234 567 8900).');
      return;
    }

    var profileAttrs = {};
    if (email) profileAttrs.email = email;
    if (phone) profileAttrs.phone_number = phone;
    var channels = [];
    if (email) channels.push('EMAIL');
    if (phone) channels.push('SMS');

    var payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: { data: { type: 'profile', attributes: profileAttrs } },
          channels: channels
        },
        relationships: {
          variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + id } }
        }
      }
    };

    jQuery.ajax({
      async: true,
      crossDomain: true,
      type: 'POST',
      headers: {
        accept: 'application/vnd.api+json',
        revision: '2024-10-15',
        'content-type': 'application/vnd.api+json'
      },
      url: 'https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=g3QNUn',
      data: JSON.stringify(payload)
    }).done(function() {
      if (phone) {
        var subscriptionPayload = {
          data: {
            type: 'subscription',
            attributes: {
              profile: { data: { type: 'profile', attributes: { phone_number: phone } } },
              custom_source: 'Back in Stock'
            },
            relationships: {
              list: { data: { type: 'list', id: 'Mjcgsv' } }
            }
          }
        };
        jQuery.ajax({
          async: true,
          crossDomain: true,
          type: 'POST',
          headers: {
            accept: 'application/vnd.api+json',
            revision: '2024-10-15',
            'content-type': 'application/vnd.api+json'
          },
          url: 'https://a.klaviyo.com/client/subscriptions?company_id=g3QNUn',
          data: JSON.stringify(subscriptionPayload)
        });
      }
      hideWaitlistError();
      if (typeof fbq === 'function') fbq('track', 'AddToWishlist');
      $('#mc-embedded-subscribe-form-waitlist .klaviyo_submit_button').each(function() {
        $(this).val("Waitlisted");
        $(this).css("background-color", "#999");
      });
      $('#mc-embedded-subscribe-form-waitlist .success_message').html("Thanks for signing up!").show();
    }).fail(function() {
      showWaitlistError('Something went wrong. Please try again.');
    });
  });

  var earlyAccessConfig = window.earlyAccessConfig || { enabled: false, granted: false, hideAll: false };
  function isFallbackEligibleProduct(p) {
    var tags = Array.isArray(p && p.tags)
      ? p.tags
      : (p && p.product && Array.isArray(p.product.tags) ? p.product.tags : []);
    var isEarlyAccessProduct = tags.indexOf('early_access') !== -1;
    if (!isEarlyAccessProduct) return true;
    if (earlyAccessConfig.hideAll) return false;
    return earlyAccessConfig.enabled && earlyAccessConfig.granted;
  }

  if(window.location.hash) {
    // IF VARIANT IS SELECTED VIA URL HASH, TRIGGER THE SWATCHES
    var h = window.location.hash
              .replace("#","")
              .toLowerCase()
              .replace("?utm_source=instagram&utm_medium=cpc","")
              .replace("earlyaccess","")
              .replace("noaccess","");
    var split = h.split('-');
    var hcolor = split[0];        
    hcolor = hcolor.replace("pi%c3%b1a","piña");

    if(split[2]){
      var hsize = split[1] +"-"+ split[2];
    } else {
      var hsize = split[1];  
    }

    hsize = hsize?.replace("-waitlist","");

    var data;
    if($('.pdp-swatches-size').length){
      data = pdp_all_products.find(p => p.color.toLowerCase().replaceAll(' ','') == hcolor && p.size.toLowerCase().replaceAll(' ','') == hsize );
    } else {
      data = pdp_all_products.find(p => p.color.toLowerCase().replaceAll(' ','') == hcolor);
    }
    // if we can't find it then default to the first available product
    if (!data) {
      data = pdp_all_products.find(p => p.product.available && isFallbackEligibleProduct(p));
    }
    // if nothing is available, default to the first product
    if (!data) {
      data = pdp_all_products.find(p => isFallbackEligibleProduct(p)) || pdp_all_products[0];
    }
  } else {
    // THERE'S NO HASH, SELECT THE FIRST AVAILABLE PRODUCT
    var data = pdp_all_products.find(p => p.product.available && isFallbackEligibleProduct(p));
    // if nothing is available, default to the first product
    if (!data) {
      data = pdp_all_products.find(p => isFallbackEligibleProduct(p)) || pdp_all_products[0];
    }
  }

  document.dispatchEvent(new CustomEvent('pdp:productchanged', {
    detail: {
      variantid: data.id,
      variant: data
    }
  }));
      
  // VILLAGE PROMO
  if (window.location.href.indexOf("utm_campaign") > -1 && window.location.href.indexOf("utm_source") > -1) {
    var percent = "20%";
    if(window.location.href.indexOf("sale25") !== -1){
      percent = "25%";
    }
    var source = $.urlParam('utm_source').split('&')[0];
    // var medium = $.urlParam('utm_medium').split('&')[0];
    if(source=="village"){
      var campaign = $.urlParam('utm_campaign').split('&')[0];
      $(".pdp-swatches").before("<div id='village-promo'>Use code <b>"+campaign+"</b> at checkout for "+percent+" off.</div>");        
    }
  }
});

/* WAITLIST */
$('.notify_me-button').click(function(e) {
  e.preventDefault();
  $("#mc-embedded-subscribe-form-waitlist").submit();
});
$('.show_waitlist-button').click(function(e) {
  e.preventDefault();
  $('.show_waitlist-button').each(function() {
      $(this).parent().hide();
  });
  $('.waitlist').each(function() {
      $(this).show();
  });
  $('.shipping_message').each(function() {
    if($(this).is(":visible")){
      $(this).hide();
    }
  });
});

$( window ).load(function() {
  // OPEN WAITLIST
  if(window.location.hash.indexOf('-WAITLIST') !== -1){
    $(".show_waitlist-button .btn").trigger("click");
    $("#mce-EMAIL").focus();

    if ($(window).width() < 640) {
      var $targetEle = $("#mc_embed_signup_waitlist");
      var targetOffset = $targetEle.offset().top - 70;

      $('html, body').stop().animate({
        'scrollTop': targetOffset
      });
    }
  }
});
